import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import fieldWrapperCss from './assets/field-wrapper.module.scss';

type PropsType = {
  additionalClassName?: string;
};

const FieldWrapper: FC<PropsWithChildren<PropsType>> = ({
  children,
  additionalClassName,
}) => (
  <div className={classNames(fieldWrapperCss.fieldWrapper, additionalClassName)}>
    {children}
  </div>
);

export { FieldWrapper };
